module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"action":{"refresh":"Refresh list"}}}')
  delete Component.options._Ctor
}
